import { useEffect, useReducer } from 'react';
import { useQuery } from '@apollo/client';
import { SAVED_SESSIONS_QUERY } from '@general/graphql/session.graph';

const useSavedSessions = () => {
    const { data, error } = useQuery(SAVED_SESSIONS_QUERY);
    const [savedSessions, dispatchSavedSessionsAction] = useReducer((currentState, { type, payload }) => {
        if (type === 'INITIALIZE') {
            const { sessions } = payload;
            return sessions;
        }

        if (type === 'REMOVE') {
            const { id } = payload;
            return currentState.filter(session => session.recordId !== id);
        }
    }, null);

    useEffect(() => {
        if (data?.sessions) {
            const sessions = data.sessions.filter(session => session !== null);
            dispatchSavedSessionsAction({ type: 'INITIALIZE', payload: { sessions } });
        }
    }, [data]);

    if (error) {
        throw error;
    }

    return { savedSessions, dispatchSavedSessionsAction };
};

export default useSavedSessions;
